import { render } from "./Steps.vue?vue&type=template&id=24daa5ea&scoped=true"
const script = {}

import "./Steps.vue?vue&type=style&index=0&id=24daa5ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24daa5ea"]])

export default __exports__